import Swiper from "swiper/bundle";

$(window).on("load", function () {
  heroSwiper();
  theaterList();
  theaterFilmCopy();
});

//==========
// gameヒーロースライダー
//==========
function heroSwiper() {
  const $heroSlider = $(".js-hero-swiper");
  if (!$heroSlider.length) return;
  // $heroSlider.css("visibility", "hidden");

  // ++++++++++++++++++++++++++++ //
  // +++ 修正箇所：画像読み込み待機 +++ //
  // ++++++++++++++++++++++++++++ //
  waitForImagesToLoad($heroSlider)
    .then(() => {
      const swiper = new Swiper($heroSlider[0], {
        lazy: { loadPrevNext: true },
        loop: true,
        autoplay: {
          delay: 2300, // 表示タイム
          disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
        },
        speed: 1500,
        slidesPerView: "auto",
        grabCursor: true,
        spaceBetween: 0,
        effect: "cube",
        cubeEffect: {
          shadow: true,
          slideShadows: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          // 768px以上の場合の設定
          768: {
            autoHeight: false,
          },
        },
      });

      // スライドhoverしている時は自動再生を停止
      $(".swiper-slide").on("mouseenter", function () {
        swiper.autoplay.stop();
      });
      $(".swiper-slide").on("mouseleave", function () {
        swiper.autoplay.start();
      });

      // ++++++++++++++++++++++++++++ //
      // +++ 高さを揃える（SP時のみ） +++ //
      // ++++++++++++++++++++++++++++ //
      function setMaxSlideHeight() {
        // まず高さをリセット
        $(".js-hero-swiper .swiper-wrapper").css("height", "");

        if (window.innerWidth < 768) {
          // 最大値を計算
          let maxHeight = 0;
          $(".js-hero-swiper .swiper-slide").each(function () {
            const h = $(this).outerHeight();
            if (h > maxHeight) maxHeight = h;
          });
          // swiper-wrapperのみに高さをセット
          $(".js-hero-swiper .swiper-wrapper").css("height", maxHeight + "px");
        }
      }

      // Swiperの高さを再計算
      setMaxSlideHeight();

      // リサイズ時
      $(window).on("resize", setMaxSlideHeight);

      // スライド切り替え時
      swiper.on("slideChange", setMaxSlideHeight);

      // ++++++++++++++++++++++++++++ //
      // +++ 修正箇所：js-loadingクラスを削除 +++ //
      // ++++++++++++++++++++++++++++ //
      // $heroSlider.removeClass("js-loading"); // swiper-initialized を検知するため不要
      //
    })
    .catch((error) => {
      console.error("Error loading images:", error);
    });

  // 画像読み込み待機
  function waitForImagesToLoad($slider) {
    const $images = $slider.find("img");
    if ($images.length === 0) return Promise.resolve();
    let loadedCount = 0;
    return new Promise((resolve) => {
      $images.each(function () {
        if (this.complete) {
          loadedCount++;
          if (loadedCount === $images.length) resolve();
        } else {
          $(this).on("load error", function () {
            loadedCount++;
            if (loadedCount === $images.length) resolve();
          });
        }
      });
    });
  }
}

//==========
// シアターリスト 並び替え
//==========
function theaterList() {
  if ($(".js-theater-list").length) {
    const containerEl = document.querySelector(".js-theater-list");
    const noteText = document.querySelector(".js-theater-list-note");

    // eslint-disable-next-line no-undef
    mixitup(containerEl, {
      multifilter: {
        enable: true,
      },
      animation: {
        effects: "fade translateZ(-100px)",
      },
      callbacks: {
        onMixStart: function(_, newState) {
          const noEntry = newState.totalShow === 0;
          if (noEntry) {
            noteText.classList.add("no-entry");
          } else {
            noteText.classList.remove("no-entry");
          }
        }
      }
    });
  }
}

//==========
// シアターフィルムを複製
// アニメーションの長さを保持するため
//==========
function theaterFilmCopy() {
  const filmEL = document.querySelector(".js-theater-film-list");

  // 対象が存在する場合の処理
  if (filmEL) {
    // 要素を完全に複製
    const clonedEl = filmEL.cloneNode(true);

    // 複製した要素を元の要素の直後に挿入
    filmEL.parentNode.insertBefore(clonedEl, filmEL.nextSibling);
    filmEL.classList.add("is-loading");
    clonedEl.classList.add("is-loading");
  } else {
    console.error(".js-theater-film-list が見つかりませんでした。");
  }
}
